"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useStyles = function useStyles() {
  return (0, _styles.makeStyles)(function (theme) {
    return {
      resultContainer: {
        display: 'flex',
        borderRadius: theme.spacing(1),
        padding: theme.spacing(1, 4.5, 1, 4.5),
        '&:hover': {
          backgroundColor: theme.palette.BLUE050
        },
        textDecoration: 'none',
        color: theme.palette.NEUTRAL900,
        '&:hover $resultTitle': {
          textDecoration: 'underline'
        }
      },
      resultContent: {
        display: 'flex',
        flexDirection: 'column',
        marginRight: theme.spacing(1.25)
      },
      openIcon: {
        color: theme.palette.BLUE400,
        fontSize: theme.typography.pxToRem(16),
        verticalAlign: 'middle'
      },
      resultTitle: {
        fontSize: theme.typography.pxToRem(16),
        fontWeight: 700,
        marginTop: theme.spacing(0),
        marginBottom: theme.spacing(1),
        marginRight: theme.spacing(1.25),
        color: theme.palette.BLUE400,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center'
      },
      title: {
        marginRight: theme.spacing(1)
      },
      resultPreview: {
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(20)
      },
      resultIcon: {
        marginTop: theme.spacing(1)
      }
    };
  })();
};
var _default = useStyles;
exports.default = _default;